import { createEvent, restore, sample } from 'effector';
import { modelFactory } from 'effector-factorio';
import { createGate } from 'effector-react';

import { getSurveyQuestionsFx, postSurveyAnswersFx } from 'shared/api';

import { FormValues } from './formValues';

export const factory = modelFactory(() => {
  const SurveyGate = createGate();

  const $questions = restore(getSurveyQuestionsFx.doneData, null);

  sample({
    clock: SurveyGate.open,
    target: getSurveyQuestionsFx,
  });

  const submitForm = createEvent<FormValues>();

  sample({
    clock: submitForm,
    source: $questions,
    fn: (questions, formData) => {
      const answers = formData.answers.map((answer, index) => ({
        ...answer,
        answerText: answer.answerText ? answer.answerText : undefined,
        questionId: questions?.questions[index].id as number,
      }));
      const surveyId = questions!.id.toString();

      return {
        survey_id: surveyId,
        data: answers,
      };
    },
    target: postSurveyAnswersFx,
  });

  return {
    $questions,
    submitForm,
    SurveyGate,
  };
});

export const baseLocalStorageKey = 'surveyForm';
